import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import styled from 'styled-components'

import { Card } from '../../components/Base/Card'
import { blueGray } from '../../theme/colors'

export const SafetyDashboardCard = styled(Card).attrs({
  hasSubtleShadow: true,
  smallerPadding: true,
  align: 'left',
})`
  padding: 24px 32px;
  position: relative;
`

export const SafetyDashboardCardWithIcon = styled(SafetyDashboardCard)`
  padding-right: 45px;
`

export const SafetyDashboardCardArrow = styled(KeyboardArrowRightIcon)`
  position: absolute;
  top: 22px;
  right: 20px;
  color: ${blueGray};
`
